import { render, staticRenderFns } from "./servicePermission.vue?vue&type=template&id=7fbcbef2&scoped=true"
import script from "./servicePermission.vue?vue&type=script&lang=js"
export * from "./servicePermission.vue?vue&type=script&lang=js"
import style0 from "./servicePermission.vue?vue&type=style&index=0&id=7fbcbef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbcbef2",
  null
  
)

export default component.exports